// Components
import { useRouter } from 'next/router';

import { useSetAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useAcl from '@/utils/hooks/user/useAcl';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';
import {
    CONTENT_ALBUMS_COMPARATIVE_TABLE,
    INSPIRATION,
    MEDIA_LIBRARY,
    SCHEDULER
} from '@/lib/routes/privateRoutes';

import { ModalUpsell } from '@/components/composite/Modals/ModalUpsell';
import { menuOverlayAtom } from '@/components/layouts/LayoutPlatform/components/Menu/menuOverlayAtom';

export const useKeyActions = () => {
    const { hasAcl } = useAcl();
    const router = useRouter();
    const setMenuOverlay = useSetAtom(menuOverlayAtom);
    const { t } = useTranslation('commons');

    return [
        {
            type: 'create_post',
            title: 'key_actions.create_post.title',
            description: 'key_actions.create_post.description',
            icon: 'scheduling-outline',
            hoverIcon: 'scheduling-solid',
            color: 'icoOrange',
            onClick: () => {
                return router.push(SCHEDULER);
            }
        },
        {
            type: 'explore_idea',
            title: 'key_actions.explore_idea.title',
            description: 'key_actions.explore_idea.description',
            icon: 'inspiration-outline',
            hoverIcon: 'inspiration-solid',
            color: 'icoPurple',
            onClick: () => {
                return router.push(INSPIRATION);
            }
        },
        {
            type: 'track_campaign',
            title: 'key_actions.track_campaign.title',
            description: 'key_actions.track_campaign.description',
            icon: 'campaign-outline',
            hoverIcon: 'campaign-solid',
            color: 'icoBlue',
            acl: {
                permissions_plan_restriction: [aclFeatures.content.campaign.read]
            },
            onClick: () => {
                if (!hasAcl(aclFeatures.content.campaign.read)) {
                    return setMenuOverlay(
                        <ModalUpsell
                            heading={t('upsell_modal.campaign.heading')}
                            description={t('upsell_modal.campaign.description')}
                            benefits={[
                                { text: t('upsell_modal.campaign.benefit1'), icon: 'check' },
                                { text: t('upsell_modal.campaign.benefit2'), icon: 'check' },
                                { text: t('upsell_modal.campaign.benefit3'), icon: 'check' },
                                { text: t('upsell_modal.campaign.benefit4'), icon: 'plus' }
                            ]}
                            illustrationPath="/images/modals/modalUpsell/campaign.png"
                            dismiss={() => setMenuOverlay('')}
                        />
                    );
                }
                return router.push(CONTENT_ALBUMS_COMPARATIVE_TABLE);
            }
        },
        {
            type: 'upload_media',
            title: 'key_actions.upload_media.title',
            description: 'key_actions.upload_media.description',
            icon: 'image-arrow-up-outline',
            hoverIcon: 'image-arrow-up-solid',
            color: 'icoGreen',
            onClick: () => {
                return router.push(MEDIA_LIBRARY);
            }
        }
    ];
};
